import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Drawer from '.';
import { Provider } from 'mobx-react';

import coreStore from '@/stores/core';
import { DrawerFuncProps } from './index';

type ConfigUpdate = DrawerFuncProps | ((prevConfig: DrawerFuncProps) => DrawerFuncProps);

export const destroyFns: (() => void)[] = [];

export type ModalFunc = (
  props: DrawerFuncProps
) => {
  destroy: () => void;
  update: (configUpdate: ConfigUpdate) => void;
};

export default function show(config: DrawerFuncProps) {
  const div = document.createElement('div');
  document.body.appendChild(div);
  let currentConfig = { ...config, close, show: true } as any;

  function destroy(...args: any[]) {
    const unmountResult = ReactDOM.unmountComponentAtNode(div);
    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }
    const triggerCancel = args.some((param) => param && param.triggerCancel);
    if (config.onClose && triggerCancel) {
      config.onClose();
    }
    for (let i = 0; i < destroyFns.length; i++) {
      const fn = destroyFns[i];
      if (fn === close) {
        destroyFns.splice(i, 1);
        break;
      }
    }
  }

  function render(props: any) {
    setTimeout(() => {
      ReactDOM.render(
        <Provider {...{ coreStore }}>
          <Drawer
            animation="zoom"
            maskAnimation="fade"
            destroyOnClose
            maskClosable
            closeIcon={null}
            modalRender={() => props.children}
            {...props}
          >
            {props.children}
          </Drawer>
        </Provider>,
        div,
      );
    });
  }

  function close(...args: any[]) {
    currentConfig = {
      ...currentConfig,
      show: false,
      afterClose: () => {
        if (typeof config.afterClose === 'function') {
          config.afterClose();
        }
        destroy(...args);
      },
    };
    render(currentConfig);
  }

  function update(configUpdate: ConfigUpdate) {
    if (typeof configUpdate === 'function') {
      currentConfig = configUpdate(currentConfig);
    } else {
      currentConfig = {
        ...currentConfig,
        ...configUpdate,
      };
    }
    render(currentConfig);
  }

  render(currentConfig);

  destroyFns.push(close);

  return {
    destroy: close,
    update,
  };
}
